import React, { useState, useEffect } from 'react';
import api from '../api';
import { Plus, Trash2, CalendarOff } from 'lucide-react';

const ABSENCE_TYPES = {
  urlaub: 'Urlaub',
  krank: 'Krankheit',
  feiertag: 'Feiertag',
  sonderurlaub: 'Sonderurlaub',
  elternzeit: 'Elternzeit',
};

const Absences = () => {
  const [absences, setAbsences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    type: 'urlaub',
    start_date: new Date().toISOString().split('T')[0],
    end_date: new Date().toISOString().split('T')[0],
    note: '',
  });

  const fetchAbsences = async () => {
    try {
      const res = await api.get('/absences');
      setAbsences(res.data);
    } catch (error) {
      console.error('Fehler:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAbsences(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/absences', form);
      setShowModal(false);
      fetchAbsences();
    } catch (error) {
      alert(error.response?.data?.error || 'Fehler beim Speichern.');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Abwesenheit wirklich löschen?')) return;
    try {
      await api.delete(`/absences/${id}`);
      fetchAbsences();
    } catch (error) {
      alert(error.response?.data?.error || 'Fehler beim Löschen.');
    }
  };

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Laden...</div>;

  return (
    <div>
      <div className="page-header">
        <div className="page-header-actions">
          <div>
            <h2>Abwesenheiten</h2>
            <p>Urlaub, Krankheit und weitere Abwesenheiten</p>
          </div>
          <button className="btn btn-primary" onClick={() => setShowModal(true)}>
            <Plus size={16} /> Neue Abwesenheit
          </button>
        </div>
      </div>

      <div className="card">
        <div className="table-container">
          {absences.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th>Art</th>
                  <th>Von</th>
                  <th>Bis</th>
                  <th>Notiz</th>
                  <th>Status</th>
                  <th>Aktionen</th>
                </tr>
              </thead>
              <tbody>
                {absences.map((absence) => (
                  <tr key={absence.id}>
                    <td><strong>{ABSENCE_TYPES[absence.type] || absence.type}</strong></td>
                    <td>{new Date(absence.start_date).toLocaleDateString('de-DE')}</td>
                    <td>{new Date(absence.end_date).toLocaleDateString('de-DE')}</td>
                    <td>{absence.note || '-'}</td>
                    <td><span className={`badge badge-${absence.status}`}>{absence.status}</span></td>
                    <td>
                      {absence.status === 'pending' && (
                        <button className="btn btn-danger btn-sm btn-icon" onClick={() => handleDelete(absence.id)} title="Löschen">
                          <Trash2 size={14} />
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="empty-state">
              <CalendarOff size={40} />
              <p>Keine Abwesenheiten eingetragen.</p>
            </div>
          )}
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Neue Abwesenheit</h3>
              <button className="btn btn-secondary btn-sm" onClick={() => setShowModal(false)}>×</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Art der Abwesenheit</label>
                  <select className="form-control" value={form.type}
                    onChange={(e) => setForm({ ...form, type: e.target.value })}>
                    {Object.entries(ABSENCE_TYPES).map(([key, label]) => (
                      <option key={key} value={key}>{label}</option>
                    ))}
                  </select>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Von</label>
                    <input type="date" className="form-control" value={form.start_date}
                      onChange={(e) => setForm({ ...form, start_date: e.target.value })} required />
                  </div>
                  <div className="form-group">
                    <label>Bis</label>
                    <input type="date" className="form-control" value={form.end_date}
                      onChange={(e) => setForm({ ...form, end_date: e.target.value })} required />
                  </div>
                </div>
                <div className="form-group">
                  <label>Notiz</label>
                  <textarea className="form-control" value={form.note}
                    onChange={(e) => setForm({ ...form, note: e.target.value })}
                    placeholder="Optionale Anmerkung..." />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Abbrechen</button>
                <button type="submit" className="btn btn-primary">Einreichen</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Absences;
